import React from 'react';
import ReactDOM from 'react-dom/client';
import {Amplify} from 'aws-amplify';
import AuthContextProvider from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationProvider';
import { GoogleMapProvider } from './contexts/GoogleMapProvider';
import Client from './appolo/Client';
// import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import config from  './graphql/amplify_outputs.json';
import configDev from './graphql/amplify_outputs_dev_sandbox.json';
import configProd from './graphql/amplify_outputs_prod.json';

// // chrome app
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then((registration) => {
//       console.log('Service Worker enregistré avec succès:', registration);
//     }).catch((error) => {
//       console.log('Enregistrement du Service Worker échoué:', error);
//     });
//   });
// };

const env = process.env.REACT_APP_ENV;

Amplify.configure(env === "prod" ? configProd : configDev);

const root = ReactDOM.createRoot(document.getElementById('root'));

// chrome app
// if ('serviceWorker' in navigator) {
//   // Rafraîchir la page quand le Service Worker prend le contrôle
//   let refreshing = false;
//   navigator.serviceWorker.addEventListener('controllerchange', () => {
//     if (refreshing) return;
//     window.location.reload();
//     refreshing = true;
//   });

//   // Register & Update SW on next build
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then((registration) => {
//       console.log('SW enregistré :', registration);

//       // 🔁 Surveille les mises à jour du Service Worker
//       registration.onupdatefound = () => {
//         const newWorker = registration.installing;
//         if (newWorker) {
//           newWorker.onstatechange = () => {
//             if (newWorker.state === 'installed') {
//               if (navigator.serviceWorker.controller) {
//                 console.log('🎯 Nouvelle version du Service Worker disponible.');

//                 // 🔥 Met automatiquement à jour et recharge la page
//                 newWorker.postMessage({ action: 'skipWaiting' });
//               }
//             }
//           };
//         }
//       };
//     });
//     navigator.serviceWorker.register('/firebase-messaging-sw.js')
//     .then(function(registration) {
//       console.log("Service Worker enregistré ✅", registration);
//     })
//     .catch(function(err) {
//       console.error("Erreur lors de l'enregistrement du SW ❌", err);
//     });
//   });
// }

// Unregister service worker
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then((registrations) => {
//     registrations.forEach((registration) => {
//       registration.unregister();
//     });
//   });
// }

// root.render(<App />);
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <NotificationProvider>
        <GoogleMapProvider>
          {/* <Client> */}
            <App />
          {/* </Client> */}
        </GoogleMapProvider>
      </NotificationProvider>
    </AuthContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
